<template>
  <div class="pt-4 block-header" v-if="overline || title || subtitle">
    <p class="text-overline" v-if="overline">{{ overline }}</p>
    <h4 v-if="title">{{ title }}</h4>
    <h6 v-if="subtitle">{{ subtitle }}</h6>
    <p v-if="description" class="pt-4">
      <vue-markdown :source="description" />
    </p>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";
export default {
  name: "BlockHeader",
  components: { VueMarkdown },
  props: {
    overline: String,
    title: String,
    subtitle: String,
    description: String,
  },
};
</script>
